import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import React, { FC } from 'react';

// Interface

export interface ImageProps {
  alt?: string;
  loading?: 'lazy' | 'eager' | undefined;
  src?: ImageDataLike | string;
}

// JSX

export const Image: FC<ImageProps> = ({ src, alt, loading, ...rest }) => {
  // if no source
  if (!src) {
    return null;
  }

  // If the image is a simple string just return a img tag
  if (typeof src === 'string') {
    return (
      <div {...rest}>
        <img src={src} alt={alt ?? ''} />
      </div>
    );
  }
  // else see if we can get the Gatstby image
  const imageData = getImage(src);
  if (!imageData) {
    return null;
  }

  return (
    <GatsbyImage
      image={imageData}
      alt={alt ?? ''}
      loading={loading}
      {...rest}
    />
  );
};

export default Image;
